// Getters
export const CONSULTANTS_SEARCH_RESULT = "consultant/CONSULTANTS_SEARCH_RESULT";
export const DNA_HISTORICAL_SEARCH_RESULT =
  "consultant/DNA_HISTORICAL_SEARCH_RESULT";
export const IMPORT_SEARCH_RESULT = "consultant/IMPORT_SEARCH_RESULT";
export const IMPORT_HISTORY_SEARCH_RESULT =
  "consultant/IMPORT_HISTORY_SEARCH_RESULT";
export const CONSULTANT_AGENT_TYPES = "consultant/CONSULTANT_AGENT_TYPES";
export const PRODUCTS = "consultant/PRODUCTS";
export const DETAILS_GENERAL_INFORMATION =
  "consultant/DETAILS_GENERAL_INFORMATION";
export const DETAILS_COMPANY_DATA = "consultant/DETAILS_COMPANY_DATA";
export const DETAILS_NETWORK_DATA = "consultant/DETAILS_NETWORK_DATA";
export const DIRECT_TEAM = "consultant/DIRECT_TEAM";
export const NEW_CONSULTANT_SIDEBAR = "consultant/NEW_CONSULTANT_SIDEBAR";
export const NEW_EMPLOYEE_SIDEBAR = "consultant/NEW_EMPLOYEE_SIDEBAR";
export const TRANSFERRED_CONSULTANTS = "consultant/TRANSFERRED_CONSULTANTS";
export const TRANSFERABLE_CONSULTANTS = "consultant/TRANSFERABLE_CONSULTANTS";
export const CHANGE_CONSULTANT_ROLE_SIDEBAR =
  "consultant/CHANGE_CONSULTANT_ROLE_SIDEBAR";
export const CHANGE_PHYSICAL_FRANCHISE_SIDEBAR =
  "consultant/CHANGE_PHYSICAL_FRANCHISE_SIDEBAR";
export const AFFILIATION_TYPES = "consultant/AFFILIATION_TYPES";
export const IMPORT_EAD_SIDEBAR = "consultant/IMPORT_EAD_SIDEBAR";
export const PENDING_PROMOTION_STEPS = "consultant/PENDING_PROMOTION_STEPS";
export const DETAILS_INDICATORS_SUMMARY =
  "consultant/DETAILS_INDICATORS_SUMMARY";
export const DETAILS_APPOINTMENT_CLOSURE_RATES =
  "consultant/DETAILS_APPOINTMENT_CLOSURE_RATES";
export const DETAILS_QUALITATIVE_HIGHLIGHTS =
  "consultant/DETAILS_QUALITATIVE_HIGHLIGHTS";
export const CONSULTANT_CERTIFICATE_SIDEBAR =
  "consultant/CONSULTANT_CERTIFICATE_SIDEBAR";
export const CONSULTANT_CERTIFICATE_TYPES =
  "consultant/CONSULTANT_CERTIFICATE_TYPES";
export const CONSULTANT_TERMINATION_REASONS =
  "consultant/CONSULTANT_TERMINATION_REASONS";
export const PROMOTION_CONTRACT_RULES =
  "consultant/PROMOTION_CONTRACT_RULES";
export const ROLE_PROMOTION_SIDEBAR = "consultant/ROLE_PROMOTION_SIDEBAR";
export const ROLE_PROMOTION_SEARCH_RESULT = "consultant/ROLE_PROMOTION_SEARCH_RESULT";
export const ROLE_PROMOTION_STATUS_TYPES = "consultant/ROLE_PROMOTION_STATUS_TYPES";

// Mutations
export const MUTATE_CONSULTANTS_SEARCH_RESULT =
  "consultant/MUTATE_CONSULTANTS_SEARCH_RESULT";
export const MUTATE_DNA_HISTORICAL_SEARCH_RESULT =
  "consultant/MUTATE_DNA_HISTORICAL_SEARCH_RESULT";
export const MUTATE_IMPORTS_SEARCH_RESULT =
  "consultant/MUTATE_IMPORTS_SEARCH_RESULT";
export const MUTATE_IMPORT_HISTORY_SEARCH_RESULT =
  "consultant/MUTATE_IMPORT_HISTORY_SEARCH_RESULT";
export const MUTATE_CONSULTANT_AGENT_TYPES =
  "consultant/MUTATE_CONSULTANT_AGENT_TYPES";
export const MUTATE_PRODUCTS = "consultant/MUTATE_PRODUCTS";
export const CLEAR_DETAILS_GENERAL_INFORMATION =
  "consultant/CLEAR_DETAILS_GENERAL_INFORMATION";
export const MUTATE_DETAILS_GENERAL_INFORMATION =
  "consultant/MUTATE_DETAILS_GENERAL_INFORMATION";
export const MUTATE_DETAILS_COMPANY_DATA =
  "consultant/MUTATE_DETAILS_COMPANY_DATA";
export const MUTATE_DETAILS_NETWORK_DATA =
  "consultant/MUTATE_DETAILS_NETWORK_DATA";
export const MUTATE_DIRECT_TEAM = "consultant/MUTATE_DIRECT_TEAM";
export const MUTATE_NEW_CONSULTANT_SIDEBAR =
  "consultant/MUTATE_NEW_CONSULTANT_SIDEBAR";
export const MUTATE_NEW_EMPLOYEE_SIDEBAR =
  "consultant/MUTATE_NEW_EMPLOYEE_SIDEBAR";
export const MUTATE_TRANSFERRED_CONSULTANTS =
  "consultant/MUTATE_TRANSFERRED_CONSULTANTS";
export const MUTATE_TRANSFERABLE_CONSULTANTS =
  "consultant/MUTATE_TRANSFERABLE_CONSULTANTS";
export const MUTATE_CHANGE_CONSULTANT_ROLE_SIDEBAR =
  "consultant/MUTATE_CHANGE_CONSULTANT_ROLE_SIDEBAR";
export const MUTATE_CHANGE_PHYSICAL_FRANCHISE_SIDEBAR =
  "consultant/MUTATE_CHANGE_PHYSICAL_FRANCHISE_SIDEBAR";
export const MUTATE_AFFILIATION_TYPES = "consultant/MUTATE_AFFILIATION_TYPES";
export const MUTATE_IMPORT_EAD_SIDEBAR = "consultant/MUTATE_IMPORT_EAD_SIDEBAR";
export const MUTATE_PENDING_PROMOTION_STEPS =
  "consultant/MUTATE_PENDING_PROMOTION_STEPS";
export const MUTATE_DETAILS_INDICATORS_SUMMARY =
  "consultant/MUTATE_DETAILS_INDICATORS_SUMMARY";
export const MUTATE_DETAILS_APPOINTMENT_CLOSURE_RATES =
  "consultant/MUTATE_DETAILS_APPOINTMENT_CLOSURE_RATES";
export const MUTATE_DETAILS_QUALITATIVE_HIGHLIGHTS =
  "consultant/MUTATE_DETAILS_QUALITATIVE_HIGHLIGHTS";
export const MUTATE_CONSULTANT_CERTIFICATE_SIDEBAR =
  "consultant/MUTATE_CONSULTANT_CERTIFICATE_SIDEBAR";
export const MUTATE_CONSULTANT_CERTIFICATE_TYPES =
  "consultant/MUTATE_CONSULTANT_CERTIFICATE_TYPES";
export const MUTATE_CONSULTANT_TERMINATION_REASONS =
  "consultant/MUTATE_CONSULTANT_TERMINATION_REASONS";
export const MUTATE_PROMOTION_CONTRACT_RULES =
  "consultant/MUTATE_PROMOTION_CONTRACT_RULES";
export const MUTATE_ROLE_PROMOTION_SIDEBAR = "consultant/MUTATE_ROLE_PROMOTION_SIDEBAR";
export const MUTATE_ROLE_PROMOTION_SEARCH_RESULT = "consultant/MUTATE_ROLE_PROMOTION_SEARCH_RESULT";
export const MUTATE_ROLE_PROMOTION_STATUS_TYPES = "consultant/MUTATE_ROLE_PROMOTION_STATUS_TYPES";

// Actions
export const SEARCH_CONSULTANTS = "consultant/SEARCH_CONSULTANTS";
export const GET_DNA_HISTORY = "consultant/GET_DNA_HISTORY";
export const SEARCH_IMPORTS = "consultant/SEARCH_IMPORTS";
export const SEARCH_IMPORT_HISTORY = "consultant/SEARCH_IMPORT_HISTORY";
export const GET_CONSULTANT = "consultant/GET_CONSULTANT";
export const SAVE_CONSULTANT = "consultant/SAVE_CONSULTANT";
export const SAVE_EMPLOYEE = "consultant/SAVE_EMPLOYEE";
export const DELETE_CONSULTANT = "consultant/DELETE_CONSULTANT";
export const GET_CONSULTANT_TERMINATION_REASONS =
  "consultant/GET_CONSULTANT_TERMINATION_REASONS";
export const DELETE_IMPORT = "consultant/DELETE_IMPORT";
export const GET_DETAILS_GENERAL_INFORMATION =
  "consultant/GET_DETAILS_GENERAL_INFORMATION";
export const GET_DETAILS_COMPANY_DATA = "consultant/GET_DETAILS_COMPANY_DATA";
export const GET_DETAILS_NETWORK_DATA = "consultant/GET_DETAILS_NETWORK_DATA";
export const GET_DIRECT_TEAM = "consultant/GET_DIRECT_TEAM";
export const OPEN_NEW_CONSULTANT_SIDEBAR =
  "consultant/OPEN_NEW_CONSULTANT_SIDEBAR";
export const OPEN_NEW_EMPLOYEE_SIDEBAR = "consultant/OPEN_NEW_EMPLOYEE_SIDEBAR";
export const GET_CONSULTANT_INFO = "consultant/GET_CONSULTANT_INFO";
export const GET_CEP = "consultant/GET_CEP";
export const SAVE_CONSULTANT_BASIC_DATA =
  "consultant/SAVE_CONSULTANT_BASIC_DATA";
export const SAVE_CONSULTANT_COMPANY_DATA =
  "consultant/SAVE_CONSULTANT_COMPANY_DATA";
export const UPDATE_CONSULTANT_CONTRACT_SIGNATURE_DATE =
  "consultant/UPDATE_CONSULTANT_CONTRACT_SIGNATURE_DATE";
export const UPDATE_CONSULTANT_CONTRACT_TERMINATION_SIGNATURE_DATE =
  "consultant/UPDATE_CONSULTANT_CONTRACT_TERMINATION_SIGNATURE_DATE";
export const TRANSFER_CONSULTANTS = "consultant/TRANSFER_CONSULTANTS";
export const GET_TRANSFERRED_CONSULTANTS =
  "consultant/GET_TRANSFERRED_CONSULTANTS";
export const GET_TRANSFERABLE_CONSULTANTS =
  "consultant/GET_TRANSFERABLE_CONSULTANTS";
export const OPEN_CHANGE_CONSULTANT_ROLE_SIDEBAR =
  "consultant/OPEN_CHANGE_CONSULTANT_ROLE_SIDEBAR";
export const CHANGE_CONSULTANT_ROLE = "consultant/CHANGE_CONSULTANT_ROLE";
export const OPEN_CHANGE_PHYSICAL_FRANCHISE_SIDEBAR =
  "consultant/OPEN_CHANGE_PHYSICAL_FRANCHISE_SIDEBAR";
export const CHANGE_PHYSICAL_FRANCHISE = "consultant/CHANGE_PHYSICAL_FRANCHISE";
export const GET_ROLE_CHANGE_IS_VALID = "consultant/GET_ROLE_CHANGE_IS_VALID";
export const GET_AFFILIATION_TYPES = "consultant/GET_AFFILIATION_TYPES";
export const DOWNLOAD_ON_CONSULTANTS = "consultant/DOWNLOAD_ON_CONSULTANTS";
export const SAVE_IMPORT_EAD = "consultant/SAVE_IMPORT_EAD";
export const SAVE_DNA_CAMPAIGN = "consultant/SAVE_DNA_CAMPAIGN";
export const GET_DNA_CAMPAIGN = "consultant/GET_DNA_CAMPAIGN";
export const OPEN_IMPORT_EAD_SIDEBAR = "consultant/OPEN_IMPORT_EAD_SIDEBAR";
export const GET_HAS_PROMOTION_CHECKLIST =
  "consultant/GET_HAS_PROMOTION_CHECKLIST";
export const GET_HAS_PENDING_PROMOTION = "consultant/GET_HAS_PENDING_PROMOTION";
export const GET_PENDING_PROMOTION_STEPS =
  "consultant/GET_PENDING_PROMOTION_STEPS";
export const UPDATE_PROMOTION_STEP = "consultant/UPDATE_PROMOTION_STEP";
export const SAVE_NETWORKER = "consultant/SAVE_NETWORKER";
export const GET_NETWORKER = "consultant/GET_NETWORKER";
export const GET_EMPLOYEE = "consultant/GET_EMPLOYEE";
export const GET_DETAILS_INDICATORS_SUMMARY =
  "consultant/GET_DETAILS_INDICATORS_SUMMARY";
export const GET_DETAILS_APPOINTMENT_CLOSURE_RATES =
  "consultant/GET_DETAILS_APPOINTMENT_CLOSURE_RATES";
export const GET_DETAILS_QUALITATIVE_HIGHLIGHTS =
  "consultant/GET_DETAILS_QUALITATIVE_HIGHLIGHTS";
export const SAVE_CONSULTANT_CERTIFICATE =
  "consultant/SAVE_CONSULTANT_CERTIFICATE";
export const UPDATE_CONSULTANT_CERTIFICATE =
  "consultant/UPDATE_CONSULTANT_CERTIFICATE";
export const GET_CONSULTANT_CERTIFICATE_TYPES =
  "consultant/GET_CONSULTANT_CERTIFICATE_TYPES";
export const GET_CONSULTANT_CERTIFICATE =
  "consultant/GET_CONSULTANT_CERTIFICATE";
export const OPEN_CONSULTANT_CERTIFICATE_SIDEBAR =
  "consultant/OPEN_CONSULTANT_CERTIFICATE_SIDEBAR";
export const DOWNLOAD_CERTIFICATE = 
  "consultant/DOWNLOAD_CERTIFICATE";
export const GET_PROMOTION_CONTRACT_RULES =
  "consultant/GET_PROMOTION_CONTRACT_RULES";
export const SEARCH_ROLE_PROMOTIONS = "consultant/SEARCH_ROLE_PROMOTIONS";
export const GET_ROLE_PROMOTION = "consultant/GET_ROLE_PROMOTION";
export const UPDATE_ROLE_PROMOTION = "consultant/UPDATE_ROLE_PROMOTION";
export const GET_ROLE_PROMOTION_STATUS_TYPES = "consultant/GET_ROLE_PROMOTION_STATUS_TYPES";
export const OPEN_ROLE_PROMOTION_SIDEBAR = "consultant/OPEN_ROLE_PROMOTION_SIDEBAR";
export const GET_CONSULTANT_ROLES_HISTORY = 'consultant/GET_CONSULTANT_ROLES_HISTORY'
export const GET_SUB_ROLE_PROGRESS = 'consultant/GET_SUB_ROLE_PROGRESS'
export const GET_SUB_ROLE_CATALOG = 'consultant/GET_SUB_ROLE_CATALOG'
export const GET_PHYSICAL_FRANCHISE_CHANGE_HISTORY = 'consultant/GET_PHYSICAL_FRANCHISE_CHANGE_HISTORY'
export const EXTEND_CONSULTANT_DEADLINE = 'consultant/EXTEND_CONSULTANT_DEADLINE'
export const PROCESS_CONSULTANT_ROLE_PROMOTION = 'consultant/PROCESS_CONSULTANT_ROLE_PROMOTION'

export const PNS_PENDING_ONBOARDING = 'consultant/PNS_PENDING_ONBOARDING'
export const MUTATE_PNS_PENDING_ONBOARDING = 'consultant/MUTATE_PNS_PENDING_ONBOARDING'
export const GET_PNS_PENDING_ONBOARDING = 'consultant/GET_PNS_PENDING_ONBOARDING'
